import { Page } from '@/core/architecture'

import { ConsoleDigitalMembershipCardTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDigitalMembershipCard Page
 * デジタル会員証画面
 */
export const ConsoleDigitalMembershipCard: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleDigitalMembershipCardTemplate state={state} {...actions} />
}
